import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCourseLessonsTableHeadings = [
	{ data: 'order', title: ls('Order') },
	{
		data: 'lessonName',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsLessonName, reportingApiSetup.learnDashLabels.lesson)
	},
	{ data: 'status', title: ls('Status') },
	{ data: 'completedDate', title: ls('Completion date') }
];

const userSingleCourseLessonsTableData = function(courseID) {
	var tableData = [];

	return tableData;
};

export {
	userSingleCourseLessonsTableHeadings,
	userSingleCourseLessonsTableData
};
